import { selectAllStrings } from '../language/languageSlice';
import { useSelector, useDispatch } from 'react-redux';
import React, { useState } from 'react';
import { selectUserPhotoById, deletePhoto } from './gallerySlice';
import { Link } from 'react-router-dom';
import constants from '../../constants';
import { PoiRating } from '../pois/PoiList';
import AskModal from '../../app/AskModal';

let Image = ({imageId, showControls = false, onDelete = f => f, selector, forceShowControls}) => {
    const image = useSelector((state) => selector(state, imageId));
    const strings = useSelector(selectAllStrings);
    const cardData = useSelector(state => state.user.cardData);

    return <div className="image">
        <div>
            <div className="poi-name">{image.nome_poi}</div>
    
            <Link className="see-poi" to={`/pois/${image.id_poi}`}>{strings.see_poi}</Link>
        </div>
        <div>
            <div className="file"><img alt="file" src={constants.backend_url + image.ga_file}/></div>
            <div className="info">
                <div className="name">{image.nominativo}</div>
                <PoiRating rating={image.average} hideEmpty={true}/>
                <div className="address">{image.address}</div>
            </div>
        </div>
                {forceShowControls || (showControls && image.ga_user == cardData.profile_id) ? <div className="controls">
                    <a href="#" 
                       onClick={event => onDelete(event, imageId)}>{strings.delete}</a>
                </div> : null}
    </div>;
};
Image = React.memo(Image);

const ImageList = ({imageIds, imagesLimit, selectById = selectUserPhotoById, forceShowControls = false}) => {
    const strings = useSelector(selectAllStrings);
    
    const [showAskModal, setShowAskModal] = useState(false);
    const [askProps, setAskProps] = useState(null);
    const dispatch = useDispatch();
    
    const onDeleteImage = (event, imageId) => {
        event.preventDefault();
        setAskProps({
            question: strings.sure_delete_image,
            onConfirm: () => {
                dispatch(deletePhoto(imageId));
                setAskProps(null);
            }
        });
    };
    
    
    
    return <div><div className="image-list">
        {imageIds.length > 0 ? imageIds.slice(0, imagesLimit).map(imageId => <Image imageId={imageId} key={imageId} 
                                                              showControls={true} forceShowControls={forceShowControls} onDelete={onDeleteImage} selector={selectById}/>) : null}
    
    </div>
    {askProps ? <AskModal message={askProps.question} onConfirm={askProps.onConfirm} onCancel={() => setAskProps(null)} /> : null}
    
    </div>
};

export default ImageList;